/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetCountry200ResponseDataCountry } from './GetCountry200ResponseDataCountry'
import {
  GetCountry200ResponseDataCountryFromJSON,
  GetCountry200ResponseDataCountryFromJSONTyped,
  GetCountry200ResponseDataCountryToJSON,
} from './GetCountry200ResponseDataCountry'

/**
 *
 * @export
 * @interface GetCountry200ResponseData
 */
export interface GetCountry200ResponseData {
  /**
   *
   * @type {GetCountry200ResponseDataCountry}
   * @memberof GetCountry200ResponseData
   */
  country: GetCountry200ResponseDataCountry
}

/**
 * Check if a given object implements the GetCountry200ResponseData interface.
 */
export function instanceOfGetCountry200ResponseData(
  value: object
): value is GetCountry200ResponseData {
  if (!('country' in value) || value['country'] === undefined) return false
  return true
}

export function GetCountry200ResponseDataFromJSON(
  json: any
): GetCountry200ResponseData {
  return GetCountry200ResponseDataFromJSONTyped(json, false)
}

export function GetCountry200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountry200ResponseData {
  if (json == null) {
    return json
  }
  return {
    country: GetCountry200ResponseDataCountryFromJSON(json['country']),
  }
}

export function GetCountry200ResponseDataToJSON(
  value?: GetCountry200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    country: GetCountry200ResponseDataCountryToJSON(value['country']),
  }
}
